import CarvanaFooter from '@carvana/footer';
import { MfeConfig, MfeLoad } from '@carvana/microfrontend';
import type { Configuration } from '@carvana/microfrontend';
import { MfeReact } from '@carvana/microfrontend-react';

export const getMfeCacheBuster = () => {
  const date = new Date();
  const nearestQuarterHour = Math.round(date.getMinutes() / 15) * 15;

  return `${date.getDate()}-${date.getHours()}-${nearestQuarterHour}`;
};

export const mfeConfigLoad = MfeConfig({
  name: 'search-ui',
  Render: MfeReact,
  // @ts-ignore TODO Remove this when we move to NextJS
  ENV: process.env.NODE_ENV,
  debug: false,
  globals: {
    React: () => import('react'),
    ReactDOM: () => import('react-dom'),
    styled: () => import('styled-components'),
    PropTypes: () => import('prop-types'),
    'styled-components': () => import('styled-components'),
    'prop-types': () => import('prop-types'),
    carvanaExperiment: () => import('@carvana/experiment'),
    carvanaShowroomTheme: () => import('@carvana/showroom-theme'),
    classnames: () => import('classnames'),
    process: () => process
  },
  files: []
});

export const mfeLoad = (configuration: Partial<Configuration>) =>
  mfeConfigLoad.then(() => MfeLoad(configuration));

export const loadHeaderMfe = () =>
  mfeLoad({
    files: [
      [
        'HeaderModule',
        [
          {
            component: 'default',
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CVNA_APP_ASSETS_CDN
              }/header/module/assets-manifest.json?v=${getMfeCacheBuster()}`
            }
          }
        ]
      ]
    ]
  });

export const loadFooterMfe = () =>
  mfeLoad({
    files: [
      [
        'FooterModule',
        [
          {
            component: 'default',
            ssrLegacy: CarvanaFooter,
            legacy: true,
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CVNA_APP_ASSETS_CDN
              }/footer/module/assets-manifest.json?v=${getMfeCacheBuster()}`
            }
          }
        ]
      ]
    ]
  });

export const loadActivationModalMfe = () =>
  mfeLoad({
    files: [
      [
        'CaActivationModal',
        [
          {
            component: 'default',
            default: {
              file: 'index.js',
              manifest: `${
                process.env.CVNA_APP_ASSETS_CDN
              }/activation-modal-module/assets-manifest.json?v=${getMfeCacheBuster()}`
            }
          }
        ]
      ]
    ]
  });
